<template>
  <form class="form-inline" @submit.prevent="buscarFilas">
    <div class="btn-group btn-group-toggle mb-2 mr-sm-2" data-toggle="buttons">
      <label v-for="tipo in tiposRango" class="btn btn-secondary text-capitalize" :class="{ disabled: loading.busqueda, active: rango == tipo }">
        <input type="radio" name="options" :value="tipo" v-model="rango" /> {{ tipo }}
      </label>
    </div>
    <div class="input-group mb-2 mr-sm-2">
      <div class="input-group-prepend">
        <div class="input-group-text">Inici</div>
      </div>
      <input type="date" class="form-control" v-model="inicio" data-test-id="rangoInicio" :min="rangoInicio" :max="fin" />
    </div>
    <div class="input-group mb-2 mr-sm-2">
      <div class="input-group-prepend">
        <div class="input-group-text">Fi</div>
      </div>
      <input type="date" class="form-control" v-model="fin" data-test-id="rangoFin" :min="inicio" :max="rangoMax" />
    </div>
    <slot></slot>
    <button ref="submit" type="submit" class="btn btn-primary mb-2" :disabled="loading.busqueda">
      <i-submit icono="fa-angles-right" :loading="loading.busqueda" />Cercar
    </button>
    <button type="reset" class="btn btn-outline-secondary mb-2 ml-2" @click="reiniciarFilas"><i class="fas fa-backspace mr-1"></i>Reiniciar</button>
  </form>
</template>

<script>
export default {
  props: {
    rangoInicio: {
      type: String,
      default: "",
    },
    rangoMax: {
      type: String,
      default: "",
    },
    tipoRango: {
      type: String,
      default: "tot",
    },
    tiposRango: {
      type: Array,
      default() {
        return ["tot", "LTM", "YTD"];
      },
    },
  },
  inject: ["rangoInicioLTM", "rangoFinLTM", "rangoInicioYTD", "rangoFinYTD", "rangoInicioLM", "rangoFinLM"],
  components: {},
  name: "rangofechas",
  data() {
    return {
      loading: {
        busqueda: false,
      },
      esFiltrado: false,
      inicio: "",
      fin: "",
      rango: "",
    }
  },
  mounted() {
    if (this.inicio && this.fin) {
      this.buscarFilas();
    }
  },
  methods: {
    buscarFilas() {
      this.$emit("buscar", { inicio: this.inicio, fin: this.fin });
    },
    reiniciarFilas() {
      this.inicio = "";
      this.fin = "";

      this.$emit("reiniciarForm");
    },
    comprobarRango() {
      switch (true) {
        case this.inicio == "" && this.fin == "":
          this.rango = "tot";
          break;
        case this.inicio == this.rangoInicioLTM && this.fin == this.rangoFinLTM:
          this.rango = "LTM";
          break;
        case this.inicio == this.rangoInicioYTD && this.fin == this.rangoFinYTD:
          this.rango = "YTD";
          break;
        case this.inicio == this.rangoInicioLM && this.fin == this.rangoFinLM:
          this.rango = "LM";
          break;
        default:
          this.rango = "";
      }
    },
  },
  watch: {
    rangoInicio: {
      handler(value) {
        this.inicio = value;
      },
      immediate: true,
    },
    fin: {
      handler() {
        this.comprobarRango();
      },
      immediate: true,
    },
    inicio: {
      handler() {
        this.comprobarRango();
      },
      immediate: true,
    },
    tipoRango: {
      handler(value) {
        this.rango = value;
      },
      immediate: true,
    },
    rango: {
      handler(value) {
        switch (value) {
          case "tot":
            this.inicio = "";
            this.fin = "";
            break;
          case "LTM":
            this.inicio = this.rangoInicioLTM;
            this.fin = this.rangoFinLTM;
            break;
          case "YTD":
            this.inicio = this.rangoInicioYTD;
            this.fin = this.rangoFinYTD;
            break;
          case "LM":
            this.inicio = this.rangoInicioLM;
            this.fin = this.rangoFinLM;
            break;
        }
      },
      immediate: true,
    },
  },
}
</script>